import type { JobSearchAssistPills } from 'src/graphql/graphql';

export const GET_JOB_SEARCH_ASSIST_ERROR = 'GET_JOB_SEARCH_ASSIST_ERROR';
export const GET_JOB_SEARCH_ASSIST_LOADING = 'GET_JOB_SEARCH_ASSIST_LOADING';
export const GET_JOB_SEARCH_ASSIST_SUCCESS = 'GET_JOB_SEARCH_ASSIST_SUCCESS';

export interface JobSearchAssistState {
  pills: JobSearchAssistPills['data'];
  isLoading: boolean;
}
export const initialState: JobSearchAssistState = {
  pills: [],
  isLoading: false,
};

export type GetJobSearchAssistLoadingAction = {
  type: typeof GET_JOB_SEARCH_ASSIST_LOADING;
};

export type GetJobSearchAssistSuccessAction = {
  type: typeof GET_JOB_SEARCH_ASSIST_SUCCESS;
  payload: {
    pills: JobSearchAssistPills['data'];
  };
};

export type GetJobSearchAssistErrorAction = {
  type: typeof GET_JOB_SEARCH_ASSIST_ERROR;
};

export type JobSearchAssistAction =
  | GetJobSearchAssistErrorAction
  | GetJobSearchAssistLoadingAction
  | GetJobSearchAssistSuccessAction;
